define('controller/form.answer.controller',['require','exports','module','fukit','model/disclosure.detail.model','model/document.answer.model','view/form.answer.page.view','formkit/formkit','backbone.radio','fukit','fukit','model/template.state.model','model/template.type.model','model/workflow.form.data.model','model/disclosure.comment.model','model/workflow.task.model'],function(require, exports, module) {
  //prettier-ignore
  var BaseController        = require('fukit').BaseController,
      DisclosureDetailModel = require('model/disclosure.detail.model'),
      DocumentAnswerModel   = require('model/document.answer.model'),
      FormAnswerPageView    = require('view/form.answer.page.view'),
      FormKit               = require('formkit/formkit'),
      Radio                 = require('backbone.radio'),
      ROLES                 = require('fukit').Roles,
      config                = require('fukit').config,
      TemplateStateModel    = require('model/template.state.model'),
      TemplateTypeModel     = require('model/template.type.model'),
      WorkflowFormDataModel = require('model/workflow.form.data.model'),
      DisclosureCommentModel= require('model/disclosure.comment.model'),
      WorkflowTaskModel     = require('model/workflow.task.model');
  var FormAnswerController = BaseController.extend({
    radioRequests: {
      'controllers FormAnswerController': '@constructor',
    },

    pageView: FormAnswerPageView,

    stateConfiguration: {
      defaults: {
        roles: [ROLES.COI_WEB_ACCESS, ROLES.COI_DISCLOSEE_WEB_ACCESS],
      },
    },

    pageViewOptions: function() {
      return {
        form: this.createForm(),
      };
    },

    resources: {
      templateType: {
        model: TemplateTypeModel,
      },
      template: {
        fetchOnStart: true,
        isFormTemplateModel: true,
        model: TemplateStateModel,
        attrs: {
          id: '@state.primaryId',
        },
      },
      documentAnswers: {
        collection: DocumentAnswerModel.BulkSaveCollection,
      },
      disclosure: {
        fetchOnStart: true,
        model: DisclosureDetailModel,
        attrs: {
          id: '@state.primaryId',
        },
      },
      workflowActivityStateModel: {
        model: Backbone.Model,
      },
      formPermissionModel: {
        model: Backbone.Model,
      },
      taskCollection: {
        fetchOnStart: true,
        collection: WorkflowTaskModel.QueryCollection,
        required: false,
      },
      workflowTaskModel: {
        fetchOnStart: true,
        required: false,
        resourcePath: '@resources.disclosure.workflowTaskModel',
      },
      taskFormDataModel: {
        fetchOnStart: true,
        model: WorkflowFormDataModel,
      },
      disclosureCommentModel: {
        model: DisclosureCommentModel,
      },
    },

    initialize: function() {
      BaseController.prototype.initialize.apply(this, arguments);

      config.set('cayuse.apps.switcher.active.name', 'MY_PROFILE');
      config.set('cayuse.menu.show', false);
      config.set('answer.mode', true);

      // task config
      this.getResource('taskCollection').requestBodyQueryModel.set({
        processInstanceVariables: [
          {
            name: 'documentId',
            operation: 'equals',
            value: this.state.get('primaryId'),
          },
        ],
      });

      this.listenTo(this.getResource('taskCollection'), 'sync', function() {
        var task = this.getResource('taskCollection').first();
        if (task) {
          this.getResource('taskFormDataModel').set({
            taskId: task.id,
          });
          this.fetchResource('taskFormDataModel');
        } else {
          this.getResource('formPermissionModel').set({ canEdit: false });
        }
      });

      // task form data config
      this.listenTo(this.getResource('taskFormDataModel'), 'sync', function() {
        var canEditFormProperty = this.getResource('taskFormDataModel')
          .get('formProperties')
          .get('canEdit');
        this.getResource('formPermissionModel').set({
          canEdit:
            String(canEditFormProperty.get('value'))
              .trim()
              .toLowerCase() == 'true',
        });
      });

      this.listenTo(
        this.getResource('disclosure.workflowTaskModel.requiredActivityCollection'),
        'update change:isComplete',
        function() {
          var workflowActivityStateModel = this.getResource('workflowActivityStateModel');
          var requiredActivityCollection = this.getResource('disclosure.workflowTaskModel.requiredActivityCollection');
          workflowActivityStateModel.set({
            areAllActivitiesComplete: Radio.request(
              'workflowActivityService',
              'areAllActivitiesComplete',
              requiredActivityCollection
            ),
          });
        }
      );

      this.listenTo(this.getResource('template'), 'sync', function() {
        this.fetchResource('disclosure.workflowTaskModel.requiredActivityCollection');
      });
    },

    createForm: function() {
      var template = this.getResource('template');

      var form = new FormKit.Form({
        templateModel: template,
      });

      return form;
    },
  });

  module.exports = FormAnswerController;
});

